// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-question--imageQuestionPrompt--QdOHUVc9 {\n  margin: 0px 20px;\n}\n.image-question--showDivider--wE9KJAsz {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dfdfdf;\n}\n.image-question--questionText--38PZn8FW {\n  margin: 0px 20px 10px 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"imageQuestionPrompt": "image-question--imageQuestionPrompt--QdOHUVc9",
	"showDivider": "image-question--showDivider--wE9KJAsz",
	"questionText": "image-question--questionText--38PZn8FW"
};
module.exports = exports;
